/**
 * Provide fonts style settings
 */

export const FontWeight: Record<App.Theme.Font.FontWeightType, string> = {
  black: '900',
  bold: '700',
  medium: '500',
  regular: '400',
  light: '300',
  thin: '100',
};
